import { PropsWithChildren, createContext, useReducer } from 'react';
import { GlobalDialogState } from 'types/molecules';

type GlobalDialogAction =
  | { type: 'OPEN_DIALOG'; payload: Omit<GlobalDialogState, 'open'> }
  | { type: 'SET_DIALOG'; payload: GlobalDialogState }
  | { type: 'CLOSE_DIALOG' };

export const DialogContext = createContext<
  | {
      state: GlobalDialogState;
      showDialog: (payload: Omit<GlobalDialogState, 'open'>) => void;
      setDialog: (payload: GlobalDialogState) => void;
      closeDialog: () => void;
      closeAfterTimeoutDialog: (timeout: number, callback?: () => void) => void;
    }
  | undefined
>(undefined);

const reducer = (state: GlobalDialogState, action: GlobalDialogAction): GlobalDialogState => {
  switch (action.type) {
    case 'OPEN_DIALOG':
      return { open: true, ...action.payload };
    case 'CLOSE_DIALOG':
      return { open: false };
    case 'SET_DIALOG':
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

const initialState: GlobalDialogState = {
  open: false,
};

export const DialogProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const showDialog = (payload: Omit<GlobalDialogState, 'open'>) => {
    dispatch({ type: 'OPEN_DIALOG', payload });
  };

  const setDialog = (payload: GlobalDialogState) => {
    // TODO: type: "OPEN_DIALOG" ???
    dispatch({ type: 'OPEN_DIALOG', payload });
  };

  const closeDialog = () => {
    dispatch({ type: 'CLOSE_DIALOG' });
  };

  const closeAfterTimeoutDialog = (timeout: number, callback?: () => void) => {
    setTimeout(() => {
      callback && callback();
      dispatch({ type: 'CLOSE_DIALOG' });
    }, timeout);
  };

  return (
    <DialogContext.Provider
      value={{ state, showDialog, setDialog, closeDialog, closeAfterTimeoutDialog }}
    >
      {children}
    </DialogContext.Provider>
  );
};
